import {
  X_CARE_BASIC_AND_CONSUME_2022,
  X_CARE_EXTEND_2022,
  NO_DEDUCTIBLE_ACT_2022,
  NO_DEDUCTIBLE_SALE_2022,
  X_CARE_PINGAN_2023_BASIC,
  X_CARE_PINGAN_2023_ADVANCE,
  X_CARE_RENEW_2022,
  X_CARE_2022_V1,
  QUALITY,
  NO,
} from '@/defination/malfunction-repair'

export const xcareTypeClassNameMap: Record<string, string[]> = {
  [X_CARE_BASIC_AND_CONSUME_2022]: ['xcare-2022-tag'], // 极加服务22版
  [X_CARE_EXTEND_2022]: ['xcare-2022-tag'], // 极加服务22版
  [X_CARE_RENEW_2022]: ['xcare-2022-tag'], // 极加服务22版
  [X_CARE_2022_V1]: ['xcare-2022-tag'], // 极加服务22版
  [NO_DEDUCTIBLE_ACT_2022]: ['no-deductible-2022-tag', 'small-type'], // 不计免赔
  [NO_DEDUCTIBLE_SALE_2022]: ['no-deductible-2022-tag', 'small-type'], // 不计免赔
  [X_CARE_PINGAN_2023_BASIC]: ['pingan-2023-base-tag', 'fix-yiwai'], // 安心保基础版
  [X_CARE_PINGAN_2023_ADVANCE]: ['pingan-2023-advance-tag', 'fix-yiwai'], // 安心保进阶版
  [QUALITY]: ['quality-service-tag', 'blue-bg'], // 质保服务
  NO: ['no-free-tag', 'small-type', 'orange-bg'], // 付费服务
  UNKNOWN: ['no-free-tag', 'small-type', 'orange-bg'], // 付费服务
}

export const TagColorMap = new Map([
  [
    NO,
    {
      color: '#F7981C',
      backgroundColor: '#fff8ef',
    },
  ],
  // 极加服务
  [
    X_CARE_BASIC_AND_CONSUME_2022,
    {
      color: '#00C378',
      backgroundColor: '#e6f9f1',
    },
  ],
  [
    X_CARE_EXTEND_2022,
    {
      color: '#00C378',
      backgroundColor: '#e6f9f1',
    },
  ],
  [
    X_CARE_RENEW_2022,
    {
      color: '#00C378',
      backgroundColor: '#e6f9f1',
    },
  ],
  [
    X_CARE_2022_V1,
    {
      color: '#00C378',
      backgroundColor: '#e6f9f1',
    },
  ],
  // 不计免赔
  [
    NO_DEDUCTIBLE_ACT_2022,
    {
      color: '#00C378',
      backgroundColor: '#e6f9f1',
    },
  ],
  [
    NO_DEDUCTIBLE_SALE_2022,
    {
      color: '#00C378',
      backgroundColor: '#e6f9f1',
    },
  ],
  // 安心保
  [
    X_CARE_PINGAN_2023_BASIC,
    {
      color: '#00C378',
      backgroundColor: '#e6f9f1',
    },
  ],
  [
    X_CARE_PINGAN_2023_ADVANCE,
    {
      color: '#00C378',
      backgroundColor: '#e6f9f1',
    },
  ],
  // 质保服务
  [
    QUALITY,
    {
      color: '#1991EB',
      backgroundColor: '#dbedfa',
    },
  ],
])
